export default {
	'expense-name': 'Expense name',
	'no-expenses-to-show': 'NO EXPENSES TO SHOW',
	'total-expenses': 'Total expenses',
}
